import { Box, Button, Typography } from '@mui/material';
import { Column } from 'components/Layout';

type Props = {
  onAddDataRoom: () => void;
};

const NoDataRoom: React.FC<Props> = ({ onAddDataRoom }) => {
  return (
    <Column centered>
      <Box sx={{ maxWidth: 420, marginY: 5 }}>
        <Column spacing="md" centered>
          <Column spacing="sm" centered>
            <Typography variant="h4">
              Showcase this opportunity with a data room
            </Typography>
            <Typography variant="body2">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              sollicitudin id metus sit amet scelerisque.
            </Typography>
          </Column>
          <Box>
            <Button onClick={onAddDataRoom} variant="contained" size="large">
              Add data room
            </Button>
          </Box>
        </Column>
      </Box>
    </Column>
  );
};

export default NoDataRoom;
